import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import { Reassurance, Why, Pillars } from "@/components/landing/Sections1";
import { Agents, Exam } from "@/components/landing/Sections2";
import { Parcours, Sources, Profiles } from "@/components/landing/Sections3";
import { HowItWorks, QuestionCTA, Faq, PartnerCTA, FinalCTA } from "@/components/landing/Sections4";
import { Temoignages } from "@/components/landing/Temoignages";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Reassurance />
        <Why />
        <Pillars />
        <Agents />
        <Exam />
        <Parcours />
        <Sources />
        <Profiles />
        <Temoignages />
        <HowItWorks />
        <QuestionCTA />
        <Faq />
        <PartnerCTA />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
